import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  summary: null,
  lastUpdated: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setSummary: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.summary = payload;
      state.lastUpdated = new Date().toISOString();
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    resetSummary: (state) => {
      state.loading = false;
      state.error = null;
      state.summary = null;
      state.lastUpdated = null;
    },
  },
});

export const { setLoading, setSummary, setError, resetSummary } = dashboardSlice.actions;

export default dashboardSlice.reducer;

export const dashboardSelector = (state) => state.dashboard;
